(function ($) {
	'use strict';

	$(function () {
		Array.from(document.querySelectorAll('.js-facet-reset')).forEach(button => {
			button.addEventListener('click', ev => {
				ev.preventDefault();
				FWP.reset();
			});
		});

		$(document).on('facetwp-refresh', function () {
			if (FWP.soft_refresh == true) {
				FWP.enable_scroll = true;
			} else {
				FWP.enable_scroll = false;
			}
		});

		$(document).on('facetwp-loaded', function () {
			const facetsLeft = document.querySelector('.js-facets-left');

			if (FWP.enable_scroll == true) {
				$('html, body').animate({
					scrollTop: $('.js-facets').offset().top - 150
				}, 500);
			}

			Array.from(document.querySelectorAll('.js-facets-reset-container')).forEach(container => {
				if ('' != FWP.buildQueryString()) {
					container.classList.add('facets__right--visible');
					facetsLeft.classList.remove('facets__left--solo');
				} else {
					container.classList.remove('facets__right--visible');
					facetsLeft.classList.add('facets__left--solo');
				};
			});

			// Modified from...
			// https://facetwp.com/help-center/facets/#how-to-add-labels-headings-above-each-facet
			$('.facetwp-facet').each(function () {
				const facet = $(this);
				const facet_name = facet.attr('data-name');
				const facet_type = facet.attr('data-type');
				const facet_label = FWP.settings.labels[facet_name];

				if (facet_type !== 'pager' && facet_type !== 'sort') {
					if (facet.closest('.facet').length < 1 && facet.closest('.facetwp-flyout').length < 1) {
						facet.wrap('<div class="facet"></div>');
						facet.before('<label class="facet__label">' + facet_label + '</label>');

						if (facet_type !== 'checkboxes') {
							const facet_input = facet.find('input, select');
							facet_input.attr('id', `facet-${facet_name}`);
							facet_input.attr('name', `facet-${facet_name}`);
							facet.prev('.facet__label').attr('for', `facet-${facet_name}`);
						}
					}
				}
			});
		});
	});
})(jQuery)
